export default __webpack_public_path__ + "static/media/Quem_Somos.acf6fb63.png";